import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon';

const styles = {
    root: {
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'space-around',
      width: '70%',
    },
    iconHover: {
      '&:hover': {
     //   backgroundColor: '#333',
    //    fill: green[200],
      },
    //  width: 40,
    //  height: 40,
   //   margin: '5px',
   //   cursor: 'pointer',
    //  boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)'
    },
  };

export const MenuToggleIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
	<path fill="none" stroke="#455a64" strokeWidth="2.1818" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" d="M19.338 22.605l-7.215-7.215 7.215-7.216"></path>
	<path fill="none" stroke="#455a64" strokeWidth="2.1818" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" d="M26.295 22.605l-7.215-7.215 7.215-7.216"></path>
   </SvgIcon>
);

export const FiltersIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
  	<path fill="none" stroke="#fff" strokeWidth="1.4545" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" d="M20.647 19.721c0 4.649-3.769 8.417-8.417 8.417s-8.417-3.769-8.417-8.417c0-4.649 3.769-8.417 8.417-8.417s8.417 3.769 8.417 8.417z"></path>
  	<path fill="#546e7a" stroke="#fff" strokeWidth="1.4545" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" d="M26.736 11.927c0 4.649-3.769 8.417-8.417 8.417s-8.417-3.769-8.417-8.417c0-4.649 3.769-8.417 8.417-8.417s8.417 3.769 8.417 8.417z"></path>
  	<path fill="#90a4ae" stroke="#fff" strokeWidth="1.4545" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" d="M33.555 19.721c0 4.649-3.769 8.417-8.417 8.417s-8.417-3.769-8.417-8.417c0-4.649 3.769-8.417 8.417-8.417s8.417 3.769 8.417 8.417z"></path>
  </SvgIcon>
);
//style="fill: var(--color3, #263238)"
// style="fill: var(--color2, #000)" 
export const MapIconBW = (props) => (
  <SvgIcon {...props} viewBox="0 0 32 32"> 
  	<g>
  		<rect fill="#78909C" width="100%" height="100%"/>
  		<g>
  			<linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="3.6494" y1="13.334" x2="23.0181" y2="13.334">
  				<stop  offset="0" style={{stopColor:'#FFFFFF'}}/>
  				<stop  offset="1" style={{stopColor:'#757575'}}/>
  			</linearGradient>
  			<path fill="url(#SVGID_1_)" d="M16.985 18.93l-1.315 1.3c0 0-6.355-0.214-7.426-0.079-0.726 0.089-2.946 2.331-3.096 2.29-1.537-0.426-0.36-4.425 0.028-5.279 0.782-1.724 0.809-3.259 2.178-4.211 0.388-0.27 1.535-0.658 1.535-0.658s2.787 4.627 4.585 3.896c1.904-0.775 1.105-2.544 0.744-4.326-0.245-1.228 2.804-2.285 2.967-2.305 0.396-0.050 4.118 2.465 4.118 2.465l2.91-0.599 1.19 1.55c0 0 1.764 4.025 2.188 4.964 0.245 0.54-1.133 2.813-1.459 3.297-0.284 0.422-2.687 1.835-4.118 0.883-1.631-1.084-4.243-1.784-4.243-1.784l-0.785-1.405z"></path>
  		</g>
  	</g>
</SvgIcon>
);

export const Routing = props => (
  <SvgIcon viewBox="0 0 32 32" {...props}>
    <g>
      <g>
        <path d="M17.5,27.7l-0.5-0.7c-0.5-0.6-4.5-6.1-4.5-8.7c0-2.8,2.2-5,5-5c2.8,0,5,2.2,5,5c0,2.6-4,8.1-4.5,8.7
          L17.5,27.7z M17.5,14.6c-2.1,0-3.7,1.7-3.7,3.7c0,1.6,2.4,5.3,3.7,7.2c1.4-2,3.7-5.6,3.7-7.2C21.2,16.3,19.5,14.6,17.5,14.6z"/>
      </g>
      <g>
        <path d="M26.1,19.5l-0.5-0.7c-0.5-0.7-2.9-4-2.9-5.6c0-1.9,1.5-3.4,3.4-3.4c1.9,0,3.4,1.5,3.4,3.4
          c0,1.7-2.4,5-2.9,5.6L26.1,19.5z M26.1,11c-1.2,0-2.1,1-2.1,2.1c0,0.8,1.2,2.8,2.1,4.2c1-1.4,2.1-3.4,2.1-4.2
          C28.2,11.9,27.2,11,26.1,11z"/>
      </g>
      <g>
        <path d="M30.2,27.8H19.3v-1.3h10.8c0.5,0,0.9-0.4,0.9-0.9v-0.2c0-0.5-0.4-0.9-0.9-0.9h-5c-1.2,0-2.2-0.9-2.2-2
          s1-2,2.2-2h5c0.6,0,0.9-0.3,0.9-0.4s-0.3-0.4-0.9-0.4h-2.7v-1.3h2.7c1.2,0,2.2,0.7,2.2,1.7c0,0.9-1,1.7-2.2,1.7h-5
          c-0.5,0-0.9,0.3-0.9,0.8s0.4,0.8,0.9,0.8h5c1.2,0,2.2,1,2.2,2.2v0.2C32.4,26.8,31.4,27.8,30.2,27.8z"/>
      </g>
    </g>
  </SvgIcon>
);

export const Car = props => (
  <SvgIcon viewBox="0 0 32 32" {...props}>
       <g>
      <g>
        <path d="M26.4,17.8H15.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h10.6c0.3,0,0.5,0.2,0.5,0.5S26.7,17.8,26.4,17.8z"/>
      </g>
      <g>
        <path d="M25,23.4h-6c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h6c0.3,0,0.5,0.2,0.5,0.5S25.3,23.4,25,23.4z"/>
      </g>
      <g>
        <path d="M27,25.2c-1.3,0-2.3-1-2.3-2.3s1-2.3,2.3-2.3s2.3,1,2.3,2.3S28.2,25.2,27,25.2z M27,21.6
          c-0.7,0-1.2,0.6-1.2,1.2s0.6,1.2,1.2,1.2s1.2-0.6,1.2-1.2S27.6,21.6,27,21.6z"/>
      </g>
      <g>
        <path  d="M16.9,25.2c-1.3,0-2.3-1-2.3-2.3s1-2.3,2.3-2.3c1.3,0,2.3,1,2.3,2.3S18.2,25.2,16.9,25.2z M16.9,21.6
          c-0.7,0-1.2,0.6-1.2,1.2s0.6,1.2,1.2,1.2c0.7,0,1.2-0.6,1.2-1.2S17.5,21.6,16.9,21.6z"/>
      </g>
      <g>
        <path d="M29.8,23.2h-0.9c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h0.9c0.2,0,0.4-0.2,0.4-0.3v-2.7c0,0-0.1-0.5-0.5-0.6
          l-3.2-0.7c-0.7-0.2-1.2-1.1-1.8-2.1c-0.3-0.5-0.8-1.5-1.1-1.5l-5,0c-0.3,0.1-0.8,1-1.1,1.5c-0.5,1-1,1.9-1.8,2.1l-2.5,0.7
          c-0.5,0.1-0.6,0.6-0.6,0.6v2.7c0,0.1,0.2,0.3,0.4,0.3h1.7c0.3,0,0.5,0.2,0.5,0.5s-0.2,0.5-0.5,0.5h-1.7c-0.7,0-1.5-0.6-1.5-1.4
          v-2.7c0-0.6,0.4-1.5,1.4-1.7l2.5-0.7c0.3-0.1,0.8-1,1.1-1.5c0.6-1.1,1.2-2.1,2-2.1h5c0,0,0,0,0,0c0.9,0,1.4,1,2,2.1
          c0.3,0.5,0.8,1.4,1,1.5l3.2,0.7c1,0.2,1.4,1.1,1.4,1.7v2.7C31.3,22.6,30.5,23.2,29.8,23.2z"/>
      </g>
    </g>
  </SvgIcon>
);

export const Pin = props => (
  <SvgIcon viewBox="0 0 32 32" {...props}>
    <path d="M21.9,28.8L21.2,28c-0.6-0.8-6-8.2-6-11.6c0-3.7,3-6.6,6.6-6.6c3.7,0,6.6,3,6.6,6.6c0,3.4-5.4,10.8-6,11.6
      L21.9,28.8z M21.9,11.3c-2.8,0-5,2.3-5,5c0,2.1,3.2,7.1,5,9.7c1.8-2.6,5-7.6,5-9.7C26.9,13.6,24.6,11.3,21.9,11.3z" />
  </SvgIcon>
);

export const Clear = props => (
    <SvgIcon viewBox="0 0 32 32" style={styles.iconHover} {...props}>
      <path d="M11.572 24.443h9.565l1.181-12.635h-11.926l1.181 12.635zM21.137 12.989l-1.063 10.273h-7.557l-0.827-10.273h9.447z"></path>
      <path d="M9.919 11.1h12.989v-1.181h-4.015c-0.236-1.181-1.181-2.125-2.48-2.125s-2.244 0.945-2.48 2.125h-4.015v1.181zM16.295 8.974c0.59 0 1.181 0.472 1.299 0.945h-2.598c0.118-0.472 0.709-0.945 1.299-0.945z"></path>
      <path d="M17.124 22.212l0.642-8.359 1.177 0.090-0.642 8.359-1.177-0.090z"></path>
      <path d="M13.738 13.989l1.177-0.091 0.643 8.359-1.177 0.091-0.643-8.359z"></path>
    </SvgIcon>
  );

export const Point = props => (
  <SvgIcon viewBox="0 0 32 32" style={typeof styles !== 'undefined' && styles.iconHover ? styles.iconHover : {}} {...props}>
    <path d="M18.066 15.941c0 0.978-0.793 1.771-1.771 1.771s-1.771-0.793-1.771-1.771c0-0.978 0.793-1.771 1.771-1.771s1.771 0.793 1.771 1.771z"></path>
  </SvgIcon>
);


export const Circle = props => (
    <SvgIcon viewBox="0 0 30 30" style={styles.iconHover} {...props}>
      <circle fill="#B2BEC9" stroke="#00264A" strokeWidth="1.1" cx="13.9" cy="14" r="6.5"/>
  </SvgIcon>
  );
  
  export const Line = props => (
    <SvgIcon viewBox="0 0 32 32" style={styles.iconHover} {...props}>
      <path d="M21.845 22.199l0.118-10.745c0.709-0.236 1.181-0.945 1.181-1.653 0-0.945-0.827-1.771-1.771-1.771s-1.771 0.827-1.771 1.771c0 0.118 0 0.236 0 0.236l-10.037 5.55c-0.354-0.236-0.709-0.472-1.181-0.472-0.945 0-1.771 0.827-1.771 1.771s0.827 1.771 1.771 1.771c0.945 0 1.771-0.827 1.771-1.771 0-0.118 0-0.236 0-0.236l10.037-5.55c0.118 0.118 0.354 0.236 0.59 0.354l-0.118 10.863c-0.59 0.236-1.063 0.945-1.063 1.653 0 0.945 0.827 1.771 1.771 1.771s1.771-0.827 1.771-1.771c0-0.945-0.472-1.653-1.299-1.771z"></path>
    </SvgIcon>
  );
  
  export const Minus = props => (
    <SvgIcon viewBox="0 0 32 32" style={styles.iconHover} {...props}>
      <path d="M23.616 17.24h-14.996c-0.708 0-1.181-0.472-1.181-1.181s0.472-1.181 1.181-1.181h14.996c0.709 0 1.181 0.472 1.181 1.181s-0.472 1.181-1.181 1.181z"></path>
    </SvgIcon>
  );

  
  export const Plus = props => (
    <SvgIcon viewBox="0 0 32 32" style={styles.iconHover} {...props}>
      <path d="M23.734 17.24h-15.114c-0.708 0-1.181-0.472-1.181-1.181s0.472-1.181 1.181-1.181h15.114c0.709 0 1.181 0.472 1.181 1.181s-0.59 1.181-1.181 1.181z"></path>
      <path d="M16.177 24.679c-0.709 0-1.181-0.472-1.181-1.181v-14.996c0-0.708 0.472-1.181 1.181-1.181s1.181 0.472 1.181 1.181v15.114c0 0.59-0.59 1.063-1.181 1.063z"></path>
    </SvgIcon>
  );
  
  export const Polygon = props => (
    <SvgIcon viewBox="0 0 28 28" style={styles.iconHover} {...props}>
        <polyline  fill="#667D92" points="18.2,19.6 18.3,8 7.3,14 18.3,20 "/>
        <circle cx="18.3" cy="20" r="1.8"/>
        <circle cx="7.3" cy="14" r="1.8"/>
        <circle cx="18.3" cy="8" r="1.8"/>
          <path d="M18.85,20.93L6.15,14l12.7-6.93V20.93z M8.45,14l9.3,5.07V8.93L8.45,14z"/>
    </SvgIcon>
  );

export const MapIconColor = (props) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
	<g>
      <rect fill="#546E7A" width="100%" height="100%"/>
      <g>
        <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="3.6494" y1="13.334" x2="23.0181" y2="13.334">
            <stop offset="0" style={{stopColor:'#C94417'}}/>
            <stop offset="0.2699" style={{stopColor:'#FFEB14'}}/>
            <stop offset="0.4908" style={{stopColor:'#77AE3E'}}/>
            <stop offset="0.7178" style={{stopColor:'#33A4E1'}}/>
            <stop offset="0.9387" style={{stopColor:'#624691'}}/>
        </linearGradient>
        <path fill="url(#SVGID_1_)" d="M16.985 18.93l-1.315 1.3c0 0-6.355-0.214-7.426-0.079-0.726 0.089-2.946 2.331-3.096 2.29-1.537-0.426-0.36-4.425 0.028-5.279 0.782-1.724 0.809-3.259 2.178-4.211 0.388-0.27 1.535-0.658 1.535-0.658s2.787 4.627 4.585 3.896c1.904-0.775 1.105-2.544 0.744-4.326-0.245-1.228 2.804-2.285 2.967-2.305 0.396-0.050 4.118 2.465 4.118 2.465l2.91-0.599 1.19 1.55c0 0 1.764 4.025 2.188 4.964 0.245 0.54-1.133 2.813-1.459 3.297-0.284 0.422-2.687 1.835-4.118 0.883-1.631-1.084-4.243-1.784-4.243-1.784l-0.785-1.405z"></path>
      </g>
    </g>
 </SvgIcon>
);

export const ReportBugs = props => (
    <SvgIcon viewBox="0 0 32 32" {...props}>
      <path d="M17.191 8.388c-5.178 0-9.32 3.003-9.32 6.628 0 1.45 0.621 2.9 1.864 4.039-0.104 1.036-0.207 2.589-0.207 2.589l-0.104 1.139 1.036-0.621c0.414-0.311 1.553-1.036 2.071-1.346 1.346 0.518 3.003 0.828 4.557 0.828 5.178 0 9.32-3.003 9.32-6.628s-4.039-6.628-9.217-6.628zM17.191 20.401c-1.553 0-3.107-0.311-4.349-0.828l-0.207-0.104-0.207 0.104c-0.311 0.104-0.932 0.518-1.45 0.828 0-0.518 0.104-1.139 0.104-1.657v-0.311l-0.207-0.207c-1.139-0.932-1.657-2.071-1.657-3.314 0-3.003 3.625-5.385 8.078-5.385s8.078 2.485 8.078 5.385-3.625 5.489-8.181 5.489z"></path>
      <path d="M11.806 12.841h10.667v1.139h-10.667v-1.139z"></path>
      <path d="M11.806 15.12h6.317v1.139h-6.317v-1.139z"></path>
      <path d="M19.366 15.12h1.139v1.139h-1.139v-1.139z"></path>
    </SvgIcon>
  );


export const SchoolIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path fill="none" stroke="#fff" strokeWidth="1.4545" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="miter" d="M6.215 13.105v14.97h6.522v-8.384h6.522v8.384h6.521v-14.97"></path>
    <path fill="none" stroke="#fff" strokeWidth="1.4545" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" d="M2.487 16.428l13.511-13.51 13.51 13.51"></path>
    <path fill="none" stroke="#fff" strokeWidth="1.4545" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="miter" d="M18.87 12.783c0 1.586-1.285 2.871-2.871 2.871s-2.871-1.286-2.871-2.871c0-1.586 1.286-2.871 2.871-2.871s2.871 1.286 2.871 2.871z"></path>
  </SvgIcon>
);

export const StudentsIcon = (props) => (
  <SvgIcon {...props}  viewBox="0 0 38 32">
  <path fill="none" stroke="#fff" strokeWidth="1.4545" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="miter" d="M18.64 20.506l-16.492-8.355 16.492-7.526 16.493 7.526z"></path>
  <path fill="none" stroke="#fff" strokeWidth="1.4545" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="miter" d="M27.226 16.637v9.673c0 0-3.434 2.656-8.503 2.656-5.071 0-8.668-2.656-8.668-2.656v-9.673"></path>
  <path fill="none" stroke="#fff" strokeWidth="1.4545" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="miter" d="M32.72 13.681v8.509"></path>
  <path fill="none" stroke="#fff" strokeWidth="1.4545" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="miter" d="M34.416 23.997c0 0.937-0.76 1.697-1.697 1.697s-1.697-0.76-1.697-1.697c0-0.937 0.76-1.697 1.697-1.697s1.697 0.76 1.697 1.697z"></path>
  </SvgIcon>
);

export const PeopleIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
  <path fill="none" stroke="#fff" strokeWidth="1.4545" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="miter" d="M12.436 17.69v3.425l-7.036 2.612c-1.631 0.58-2.72 2.159-2.72 3.892v2.167h26.016v-2.167c0-1.732-1.136-3.311-2.769-3.892l-6.986-2.612v-3.693"></path>
  <path fill="none" stroke="#fff" strokeWidth="1.4545" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="miter" d="M22.329 10.348c0 4.529-3.060 8.202-6.832 8.202-3.776 0-6.835-3.673-6.835-8.202 0-4.525 3.059-8.199 6.835-8.199 3.772 0 6.832 3.673 6.832 8.199z"></path>
  <path fill="none" stroke="#fff" strokeWidth="1.4545" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="miter" d="M22.303 9.623c-0.23 0.028-0.426 0-0.656 0.044-2.33 0.448-3.824-0.397-5.105-2.639-0.769 1.473-3.174 2.639-5.148 2.639-0.972 0-1.808-0.201-2.646-0.639"></path>
  </SvgIcon>
);

export const Place = props => (
  <SvgIcon viewBox="0 0 32 32" {...props}>
    <path fill="#666" d="M27.236 25.683h-18.641l-0.207-5.074h2.589v-6.628h1.346v-3.521l2.175-1.864 2.175 1.968v3.521h1.45v6.628h2.382v-4.764l1.761-1.553 1.864 1.553v2.485h3.003v7.249zM9.735 24.44h16.259v-4.764h-3.003v-3.107l-0.621-0.518-0.518 0.518v5.385h-4.867v-6.628h-1.45v-4.246l-1.036-0.828-0.932 0.828v4.246h-1.346v6.628h-2.589l0.104 2.485z"></path>
    <path fill="#666" d="M13.877 7.042h1.243v2.485h-1.243v-2.485z"></path>
  </SvgIcon>
);


export const InfrastructureIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
  <path fill="none" stroke="#fff" strokeWidth="1.4545" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="miter" d="M28.442 15.943c0 6.83-5.537 12.367-12.367 12.367s-12.367-5.537-12.367-12.367c0-6.83 5.537-12.367 12.367-12.367s12.367 5.537 12.367 12.367z"></path>
  <path fill="none" stroke="#fff" strokeWidth="1.4545" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="miter" d="M9.303 26.431c0.716-10.397 9.101-17.12 16.199-18.54"></path>
  <path fill="none" stroke="#fff" strokeWidth="1.4545" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="miter" d="M4.653 11.257c5.657 2.131 10.605 6.221 13.732 11.94 0.778 1.424 1.412 2.889 1.904 4.378"></path>
  <path fill="none" stroke="#fff" strokeWidth="1.4545" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="miter" d="M27.83 19.805c-6.567-1.833-12.417-6.211-15.946-12.665-0.428-0.784-0.813-1.58-1.152-2.383"></path>
 </SvgIcon>
);

export const ArrowToggle = (props) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
  <path fill="none" stroke="#455a64" strokeWidth="2.1818" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" d="M19.338 22.605l-7.215-7.215 7.215-7.216"></path>
  <path fill="none" stroke="#455a64" strokeWidth="2.1818" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" d="M26.295 22.605l-7.215-7.215 7.215-7.216"></path>
   </SvgIcon>
);

export const SchoolMapIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
  <path fill="none" stroke="#009688" strokeWidth="1.6437" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" d="M13.513 4.825h-8.483v17.5h5.963"></path>
  <path fill="none" stroke="#009688" strokeWidth="1.6437" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" d="M11.137 22.509l6.311 5.532 0.016-6.316"></path>
  <path fill="none" stroke="#37474f" strokeWidth="1.6437" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" d="M21.122 22.324h8.382v-17.5h-11.906"></path>
  <path fill="none" stroke="#37474f" strokeWidth="1.6437" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" d="M17.427 4.816v4.828"></path>
  <path fill="none" stroke="#37474f" strokeWidth="1.6437" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" d="M20.354 12.765h6.020"></path>
  <path fill="none" stroke="#37474f" strokeWidth="1.6437" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" d="M20.354 16.68h6.020"></path> </SvgIcon>
);

export const MobilityIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 38 32">
  <path fill="#fff" stroke="#fff" strokeWidth="0.4545" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="miter" d="M35.695 9.348c0-0.026 0-0.052-0.001-0.079l-0.003-0.607h-0.051c-0.329-2.017-2.087-3.562-4.234-3.562h-18.947l-10.822-0.068v9.795l0.015 0.068v8.428h3.721c-0.038 0.23-0.071 0.463-0.071 0.704 0 2.342 1.905 4.247 4.247 4.247s4.246-1.905 4.246-4.247c0-0.241-0.032-0.474-0.071-0.704h9.204c-0.038 0.23-0.071 0.463-0.071 0.704 0 2.342 1.905 4.247 4.247 4.247 2.34 0 4.246-1.905 4.246-4.247 0-0.241-0.032-0.474-0.071-0.704h4.42v-8.428h-0.004v-5.548zM24.803 6.556h6.644c1.54 0 2.791 1.252 2.787 2.835l0.004 4.051h-9.436v-6.886zM13.913 6.556h9.436v6.886h-9.436v-6.886zM3.023 6.556h9.436v6.886h-9.436v-6.886zM9.548 26.82c-1.54 0-2.793-1.252-2.793-2.793 0-0.369 0.076-0.721 0.208-1.044l0.041-0.090c0.103-0.231 0.243-0.439 0.399-0.63 0.025-0.029 0.047-0.058 0.071-0.087 0.164-0.185 0.348-0.349 0.553-0.483 0.010-0.007 0.020-0.012 0.031-0.017 0.191-0.121 0.397-0.212 0.611-0.284 0.052-0.017 0.105-0.033 0.159-0.049 0.233-0.063 0.473-0.105 0.72-0.105s0.487 0.042 0.72 0.106c0.054 0.015 0.105 0.031 0.157 0.048 0.215 0.073 0.423 0.163 0.614 0.285 0.009 0.006 0.019 0.009 0.028 0.015 0.205 0.135 0.39 0.301 0.556 0.486 0.025 0.028 0.047 0.057 0.070 0.084 0.157 0.191 0.297 0.399 0.4 0.631l0.041 0.090c0.131 0.324 0.207 0.675 0.207 1.044 0.001 1.54-1.249 2.793-2.79 2.793zM27.103 26.82c-1.54 0-2.793-1.252-2.793-2.793 0-0.371 0.077-0.723 0.209-1.047l0.038-0.089c0.103-0.23 0.241-0.436 0.396-0.625 0.026-0.031 0.049-0.063 0.077-0.092 0.163-0.183 0.346-0.348 0.551-0.481 0.012-0.007 0.025-0.012 0.035-0.019 0.188-0.121 0.394-0.211 0.607-0.281 0.052-0.019 0.105-0.035 0.16-0.051 0.231-0.063 0.471-0.105 0.719-0.105 0.249 0 0.489 0.042 0.721 0.106 0.052 0.015 0.103 0.031 0.153 0.048 0.218 0.073 0.431 0.164 0.624 0.288 0.006 0.004 0.013 0.007 0.019 0.012 0.208 0.135 0.393 0.301 0.559 0.487 0.025 0.028 0.047 0.055 0.070 0.084 0.156 0.191 0.294 0.397 0.399 0.628 0 0.001 0.001 0.004 0.003 0.006l0.033 0.077c0.134 0.326 0.211 0.681 0.211 1.055 0.001 1.539-1.249 2.791-2.79 2.791zM34.153 21.869h-3.401c-0.013-0.022-0.032-0.036-0.045-0.058-0.182-0.294-0.39-0.569-0.634-0.809h-0.001c-0.234-0.23-0.5-0.423-0.783-0.593-0.071-0.044-0.145-0.081-0.22-0.119-0.225-0.119-0.461-0.217-0.708-0.294-0.084-0.028-0.164-0.057-0.252-0.079-0.324-0.080-0.657-0.134-1.005-0.134s-0.682 0.054-1.005 0.134c-0.089 0.022-0.17 0.052-0.257 0.080-0.244 0.077-0.477 0.172-0.7 0.289-0.079 0.041-0.153 0.080-0.228 0.125-0.276 0.167-0.537 0.356-0.767 0.58-0.004 0.004-0.010 0.009-0.016 0.013-0.243 0.239-0.449 0.513-0.631 0.806-0.013 0.022-0.032 0.036-0.045 0.058h-10.257c-0.012-0.020-0.031-0.035-0.044-0.055-0.182-0.294-0.388-0.57-0.634-0.812 0 0-0.001-0.001-0.003-0.003-0.233-0.227-0.497-0.42-0.778-0.589-0.074-0.045-0.148-0.083-0.224-0.122-0.224-0.118-0.458-0.214-0.704-0.292-0.087-0.025-0.17-0.057-0.257-0.079-0.324-0.080-0.657-0.134-1.005-0.134s-0.682 0.054-1.005 0.134c-0.087 0.022-0.169 0.052-0.255 0.080-0.246 0.077-0.48 0.173-0.704 0.291-0.076 0.039-0.151 0.077-0.225 0.122-0.279 0.169-0.543 0.361-0.775 0.588-0.003 0.001-0.006 0.003-0.007 0.006-0.244 0.24-0.452 0.515-0.634 0.809-0.013 0.022-0.032 0.035-0.044 0.057h-2.793v-6.884h31.047v6.884z"></path>
</SvgIcon>
);

export const LayerChange = (props) => <SvgIcon viewBox="-2 -10 38 38" {...props}>
<path d="M24.78,3.26h-3.95V0.75c0-0.41-0.34-0.75-0.75-0.75H1C0.58,0,0.25,0.34,0.25,0.75v19.08
  c0,0.27,0.15,0.5,0.36,0.63c0.03,0.04,3.34,0.12,3.34,0.12v3.51c0,0.41,0.34,0.75,0.75,0.75h20.08c0.41,0,0.75-0.34,0.75-0.75V4.01
  C25.53,3.6,25.19,3.26,24.78,3.26z M17.76,19.08c-0.02-0.02-0.03-0.05-0.05-0.07l-4.33-3.8l5.95-5.86v9.74H17.76z M19.33,1.5v5.74
  l-7.08,6.97L1.75,4.99c0,0,0,0,0,0V1.5H19.33z M1.75,6.98l6.2,5.45l-6.2,6.08V6.98z M9,13.5c0.03-0.03,0.04-0.06,0.06-0.09
  l6.46,5.67H3.31L9,13.5z M24.03,23.34H5.45v-2.76h14.63c0.41,0,0.75-0.34,0.75-0.75V4.76h3.2V23.34z"/>
<path d="M11.52,11.73c0.14,0.12,0.31,0.18,0.48,0.18c0.21,0,0.41-0.08,0.56-0.25l3.14-3.51C15.83,8,15.9,7.8,15.88,7.6
  s-0.11-0.39-0.26-0.52l-4.69-3.95C10.62,2.87,10.16,2.9,9.89,3.2L6.75,6.71c-0.13,0.15-0.2,0.35-0.19,0.55s0.11,0.39,0.26,0.52
  L11.52,11.73z M10.52,4.74l3.54,2.98l-2.14,2.39L8.38,7.14L10.52,4.74z"/>
</SvgIcon>;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/components/icons/index.js